import { useAuthStore } from '@/stores/auth';
import { storeToRefs } from 'pinia';

export function useAuth() {
    const auth = useAuthStore();
    const { user, ready, isAuthenticated, isProfileCompleted, activeCompany } = storeToRefs(auth);
    return {
        user,
        ready,
        isAuthenticated,
        isAdmin: auth.isAdmin,
        login: auth.login,
        signOut: auth.signOut,
        isProfileCompleted,
        activeCompany,
    };
}
